var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStyle = function SvgStyle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87 9.18.44 15.04c-.41 1.02.08 2.19 1.09 2.61l1.34.56zm18.16 4.77L16.07 1.98A2.01 2.01 0 0 0 14.26.75c-.26 0-.53.04-.79.15L6.1 3.95a2 2 0 0 0-1.08 2.6l4.96 11.97a2 2 0 0 0 2.6 1.08l7.36-3.05a1.994 1.994 0 0 0 1.09-2.6m-8.83 3.647a.4.4 0 0 1-.523-.217L7.023 6.16a.4.4 0 0 1 .217-.523l6.61-2.734a.4.4 0 0 1 .523.216l4.654 11.212a.4.4 0 0 1-.216.522z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.33 19.75l-3.45-8.34v6.34c0 1.1.9 2 2 2z"
  })));
};
export default SvgStyle;